import React from 'react';
import './DatePickerModalTitle.less';
import DateRangeDisplay from '../DateRangeDisplay/DateRangeDisplay';

const className = 'date-picker-modal-title';

const DatePickerModalTitle = ({
    locale,
    startLabel,
    endLabel,
    startDate,
    endDate,
    isSelecting,
}) => {
    return (
        <div className={className}>
            <DateRangeDisplay
                locale={locale}
                startLabel={startLabel}
                endLabel={endLabel}
                startDate={startDate}
                endDate={endDate}
                isSelecting={isSelecting}
            />
        </div>
    );
};

export default DatePickerModalTitle;
